import { useNavigate, useSearch } from '@tanstack/react-router';

import { Tabs } from '../../cdl/Tabs/Tabs';

import { StatisticTab } from './StatisticTab';

export const CustomerStatisticsTabSwitch = () => {
    const search = useSearch({ from: '/_app/statistics' });
    const navigate = useNavigate({ from: '/statistics' });

    return (
        <Tabs
            selectedContext={search.tab}
            onSelect={(tab: StatisticTab) => {
                navigate({
                    search: (previousSearch) => ({
                        ...previousSearch,
                        tab,
                    }),
                });
            }}
            totals={{
                [StatisticTab.GENERAL]: null,
                [StatisticTab.VESSELS]: null,
                [StatisticTab.SUPPLIERS]: null,
                [StatisticTab.PORTS]: null,
                [StatisticTab.PRODUCTS]: null,
                [StatisticTab.PRODUCT_GROUPS]: null,
            }}
        />
    );
};
